import React, { useContext, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useSelector, useDispatch } from 'react-redux';
// eslint-disable-next-line import/no-cycle
import { useTranslation } from 'react-i18next';
import CardItem from './CardItem';
import { Context } from './ContextWrapper';
import { fetchDocumentType } from '../Store/SystemMasters.action';

function CardContent({ documentMasterTypes }) {
  const { cards } = useContext(Context);
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const csList = useSelector((state) => state);
  const {
    UserDetails: { userInfo },
  } = csList;

  useEffect(() => {
    if (userInfo.userId && documentMasterTypes?.value === 'specification') {
      dispatch(fetchDocumentType({}, t));
    }
  }, [dispatch, userInfo, documentMasterTypes]);

  return (
    <PerfectScrollbar>
      <ul>
        {cards.map((card, index) => (
          <CardItem key={card?._id || index} cards={cards} index={index} item={card} />
        ))}
      </ul>
    </PerfectScrollbar>
  );
}

export default CardContent;
